import React from "react";
import localeText from "../../../../../locale";
import { Button } from "primereact/button";

const DiagnosisProgressCard = ({ currentStep, totalSteps, onContinue }) => {
  const safeTotal = totalSteps || 8;
  const safeCurrent = Math.min(Math.max(currentStep || 1, 1), safeTotal);
  const progress = (safeCurrent / safeTotal) * 100;

  return (
    <div className="px-4">
      <div
        className="border-round p-3 my-3"
        style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff" }}
      >
        <div className="text-sm font-medium mb-1">
          {localeText("businessDiagnosisInProgress") || "Diagnosi Aziendale in Sospeso"}
        </div>
        <p className="text-xs m-0 mb-3" style={{ opacity: 0.8 }}>
          {localeText("businessDiagnosisProgressDescription") ||
            "Scopri come rendere la tua azienda più economica e sostenibile."}
        </p>
        <div className="text-xs mb-2" style={{ opacity: 0.8 }}>
          {localeText("businessDiagnosisProgressLabel") || "Avanzamento:"}{" "}
          {localeText("businessDiagnosisProgressStep", {
            current: safeCurrent,
            total: safeTotal,
          }) || `Fase ${safeCurrent} di ${safeTotal}`}
        </div>
        <div
          className="border-round overflow-hidden mb-2"
          style={{ height: "8px", backgroundColor: "var(--theme-background)" }}
        >
          <div
            style={{
              width: `${progress}%`,
              height: "100%",
              backgroundColor: "var(--theme-text)",
            }}
          />
        </div>
        <Button
          className="p-button-text p-0 mt-2 text-sm font-medium underline p-no-outline"
          style={{
            color: "var(--theme-background)",
          }}
          onClick={onContinue}
        >
          {localeText("businessDiagnosisContinue") || "Continua la Diagnosi"}
        </Button>
      </div>
    </div>
  );
};

export default DiagnosisProgressCard;
